// Baselayer Background Checks — shared label + tone maps so the list, detail,
// and UCC surfaces read the same status vocabulary.

import type { StatusTone } from "@/design-system/components/ui";
import type {
  BackgroundCheckStatus,
  BackgroundCheckType,
} from "@/api/backgroundChecks/backgroundChecksApi";
import type {
  BgcUccFilingStatus,
  BgcUccFilingType,
} from "@/api/backgroundChecks/bgcUccFilingApi";

export const CHECK_TYPE_LABELS: Record<BackgroundCheckType, string> = {
  Kyb: "KYB (Business)",
  Ofac: "OFAC",
  Pep: "PEP",
  Dmf: "Death Master File",
  Online: "Online / Website",
  LienSearch: "Lien Search",
};

export const CHECK_STATUS_LABELS: Record<BackgroundCheckStatus, string> = {
  Draft: "Draft",
  Submitted: "Submitted",
  Processing: "Processing",
  Completed: "Completed",
  Failed: "Failed",
  Filed: "Filed",
};

export function checkStatusTone(status: BackgroundCheckStatus): StatusTone {
  switch (status) {
    case "Completed":
      return "ok";
    case "Filed":
      return "info";
    case "Failed":
      return "danger";
    case "Submitted":
    case "Processing":
      return "progress";
    default:
      return "neutral";
  }
}

export const UCC_FILING_TYPE_LABELS: Record<BgcUccFilingType, string> = {
  Ucc1: "UCC-1",
  Ucc3Continuation: "UCC-3 Continuation",
  Ucc3Amendment: "UCC-3 Amendment",
  Ucc3Assignment: "UCC-3 Assignment",
  Ucc3Termination: "UCC-3 Termination",
};

export const UCC_FILING_STATUS_LABELS: Record<BgcUccFilingStatus, string> = {
  Draft: "Draft",
  PendingApproval: "Pending approval",
  Approved: "Approved",
  FilingSubmitted: "Filing submitted",
  Filed: "Filed",
  FilingRejected: "Rejected",
  Withdrawn: "Withdrawn",
};

export function uccStatusTone(status: BgcUccFilingStatus): StatusTone {
  switch (status) {
    case "Filed":
      return "ok";
    case "Approved":
    case "FilingSubmitted":
      return "info";
    case "PendingApproval":
      return "progress";
    case "FilingRejected":
      return "danger";
    case "Withdrawn":
      return "muted";
    default:
      return "neutral";
  }
}
